import React from 'react';

function ChevronLeftIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M4.7,9c-0.6,0.6-0.6,1.5,0,2l8.6,8.6c0.6,0.6,1.5,0.6,2,0c0.6-0.6,0.6-1.5,0-2L7.7,10l7.6-7.6c0.6-0.6,0.6-1.5,0-2c-0.6-0.5-1.5-0.6-2,0L4.7,9L4.7,9z"/>
    </svg>
  );
}

export default ChevronLeftIcon;
